import { posAxiosClient } from '@kinderlabs-pos/apis/axios';
import { MultiUseTicketType } from '@kinderlabs-pos/shared-data-type';

export const cancelUseMutAsync =
	(rootUrl: string) =>
	async ({ storeId, posId, memberId, orderId, ticketUsageId }: UseMutAsyncRequestType) =>
		(
			await posAxiosClient.post<MultiUseTicketType>(
				`${rootUrl}/ticket/mut/store/${storeId}/pos/${posId}/use/cancel`,
				{
					memberId,
					orderId,
				},
				{
					params: {
						ticketUsageId,
					},
				}
			)
		).data;

export type UseMutAsyncRequestType = {
	ticketUsageId: number;
	orderId: string;
	memberId: number;
	storeId: number;
	posId: number;
};
